/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useState, useCallback, useEffect } from 'react';
import TimeRangeFilter from 'AdsUI/components/TimeRangeFilter';
import { connect } from 'react-redux';
import { changeFilters } from 'AdsUI/actions/GlobalFilterActions';
import GlobalFiltersRecord from 'AdsUI/records/reporting/GlobalFiltersRecord';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';
import { PRESET_TYPES } from '../lib/AdsSimpleDateRange';

const GlobalTimeRangeFilterContainer = ({
  globalFilters,
  showAllTime,
  placement,
  changeFilters: dispatchChangeFilters
}) => {
  const [timeRangeValue, setTimeRangeValue] = useState(globalFilters.timeRange);
  useEffect(() => {
    setTimeRangeValue(globalFilters.timeRange);
  }, [globalFilters.timeRange]);
  const onChange = useCallback(e => {
    const timeRange = e.target.value;
    setTimeRangeValue(timeRange);

    if (timeRange.type !== PRESET_TYPES.CUSTOM || timeRange.startDate && timeRange.endDate) {
      dispatchChangeFilters({
        timeRange
      });
    }
  }, [dispatchChangeFilters]);
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.dateFilterLabel"
    }),
    children: /*#__PURE__*/_jsx(TimeRangeFilter, {
      timeRangeRecord: timeRangeValue,
      onChange: onChange,
      showAllTime: showAllTime,
      placement: placement
    })
  });
};

GlobalTimeRangeFilterContainer.propTypes = {
  globalFilters: PropTypes.instanceOf(GlobalFiltersRecord),
  showAllTime: PropTypes.bool,
  placement: PropTypes.string
};
GlobalTimeRangeFilterContainer.defaultProps = {
  showAllTime: true
};
export default connect(state => {
  return {
    globalFilters: getGlobalFilters(state)
  };
}, {
  changeFilters
})(GlobalTimeRangeFilterContainer);